// extracted by mini-css-extract-plugin
module.exports = {"theList":"TaskGroupItem_theList__1RtHY","taskGroupItem":"TaskGroupItem_taskGroupItem__1RxJg","taskGroupItemHeader":"TaskGroupItem_taskGroupItemHeader__1cqFE"};